import { render, staticRenderFns } from "./CallTableProjectActions.vue?vue&type=template&id=d2d3ddf4"
import script from "./CallTableProjectActions.vue?vue&type=script&lang=js"
export * from "./CallTableProjectActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports